import { render, staticRenderFns } from "./invoice-config.vue?vue&type=template&id=090ba3ff&scoped=true"
import script from "./invoice-config.vue?vue&type=script&lang=js"
export * from "./invoice-config.vue?vue&type=script&lang=js"
import style0 from "./invoice-config.vue?vue&type=style&index=0&id=090ba3ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ba3ff",
  null
  
)

export default component.exports